import { Box, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const confirmationDialogPaperPropsStyle = {
  padding: '1rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  maxWidth: '21.8rem',
  width: '100%',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    maxWidth: '30rem',
    padding: '1.5rem',
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '40.625rem',
    padding: '2rem',
  },
};
export const TagSpaceInputAndCpf = styled('div')(() => ({
  height: '5rem',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '1rem',
}));

export const TagSeller = styled('div')(() => ({
  position: 'relative',
  bottom: '1.5rem',
}));

export const StyledIconButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  color: theme.palette.common.white,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
}));

export const StyledDialogContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  textAlign: 'center',
  padding: '1rem',
  width: '100%',
  maxHeight: '40rem',
}));

export const StyledImage = styled('img')({
  width: '12rem',
  height: '12rem',

  [theme.breakpoints.up('sm')]: {
    width: '9rem',
    height: '9rem',
  },

  [theme.breakpoints.up('md')]: {
    width: '10rem',
    height: '10rem',
  },
});

export const StyledButtonContainer = styled(Box)({
  paddingTop: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '1rem',
  },
});
